import React from 'react';

import { CheckmarkAnimation } from '@eika/checkmark-animation';

import { MessageType } from './types';

interface CheckmarkProps {
    type: MessageType | undefined;
}

export const Checkmark = ({ type }: CheckmarkProps) => {
    if (type !== MessageType.SUCCESS_WITH_CHECKED) {
        return null;
    }

    return <CheckmarkAnimation key={2000} />;
};

interface TextProps {
    text: string | undefined;
}

export const Title = ({ text }: TextProps) => {
    if (typeof text === 'undefined') {
        return null;
    }

    return <h1 className="message-title">{text}</h1>;
};

export const InfoText = ({ text }: TextProps) => {
    if (typeof text === 'undefined') {
        return null;
    }

    return <p className="message-text lead">{text}</p>;
};
